<template>
    <div class="container-fluid layout-wrapper">
        <div class="row">
            <div class="col-lg-6 offset-lg-3">
                <div class="layout-wrapper">
                    <div class="card card-primary shadow">
                        <div class="card-body">
                            <h2 class="text-center">تنظیمات</h2>
                            <div class="row mt-3">
                                <!--<div class="col-lg-4 mb-4" @click="onThemeChange($event, 'light')">
                                    <div class="theme-item light clickable"></div>
                                </div>
                                <div class="col-lg-4 mb-4" @click="onThemeChange($event, 'light-orange')">
                                    <div class="theme-item light-orange clickable"></div>
                                </div>
                                <div class="col-lg-4 mb-4" @click="onThemeChange($event, 'light-purple')">
                                    <div class="theme-item light-purple clickable"></div>
                                </div>
                                <div class="col-lg-4 mb-4" @click="onThemeChange($event, 'cosmic')">
                                    <div class="theme-item cosmic clickable"></div>
                                </div>
                                <div class="col-lg-4 mb-4" @click="onThemeChange($event, 'dark-red')">
                                    <div class="theme-item dark-red clickable"></div>
                                </div>
                                <div class="col-lg-4 mb-4" @click="onThemeChange($event, 'dark-blue')">
                                    <div class="theme-item dark-blue clickable"></div>
                                </div>-->
                                <div class="col-10 mt-3">
                                    <h5>حالت شب</h5>
                                </div>
                                <div class="col-2 text-left">
                                    <toggle-button id="changed-font" class="m-0 ml-5"
                                                   :color="{checked: '#29b6f6', unchecked: '#90a4ae'}" :value="darkMode"
                                                   :sync="true" @change="onThemeChange($event)"/>
                                </div>
                                <!--<div class="col-10 mt-3">-->
                                    <!--<h5>مجوز لایک به کاربران</h5>-->
                                <!--</div>-->
                                <!--<div class="col-2 text-left">-->
                                    <!--<toggle-button id="changed-font" class="m-0 ml-5"-->
                                                   <!--:color="{checked: '#29b6f6', unchecked: '#90a4ae'}" :value="showLike"-->
                                                   <!--:sync="true" @change="onLikeChange($event)"/>-->
                                <!--</div>-->
                                <!--<div class="col-10 mt-3">-->
                                    <!--<h5>مجوز ثبت دیدگاه به کاربران</h5>-->
                                <!--</div>-->
                                <!--<div class="col-2 text-left">-->
                                    <!--<toggle-button id="changed-font" class="m-0 ml-5"-->
                                                   <!--:color="{checked: '#29b6f6', unchecked: '#90a4ae'}"-->
                                                   <!--:value="showComment" :sync="true" @change="onCommentChange($event)"/>-->
                                <!--</div>-->
                                <!--<div class="col-10 mt-3">-->
                                    <!--<h5>مجوز ثبت پیام و درخواست به کاربران</h5>-->
                                <!--</div>-->
                                <!--<div class="col-2 text-left">-->
                                    <!--<toggle-button id="changed-font" class="m-0 ml-5"-->
                                                   <!--:color="{checked: '#29b6f6', unchecked: '#90a4ae'}"-->
                                                   <!--:value="showRequest" :sync="true" @change="onRequestChange($event)"/>-->
                                <!--</div>-->
                                <!--<div class="col-lg-4 mb-4" @click="onThemeChange($event, 'default')">
                                    <div class="theme-item default clickable"></div>
                                </div>-->
                            </div>
                            <!--<div class="col-lg-6 offset-lg-3 text-center">-->
                                <!--<label class="btn btn-primary btn-round clickable mt-3"-->
                                       <!--@click="updateOption">ثبت اطلاعات</label>-->
                            <!--</div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<button class="btn btn-primary" @click="onThemeChange($event, 'light')">Light</button>
        <button class="btn btn-primary" @click="onThemeChange($event, 'cosmic')">Cosmic</button>-->
    </div>
</template>

<script>
    import EventBus from "../_framework/event-bus";
    import BaseService from "../_framework/api/BaseService";

    export default {
        name: "settings",
        data() {
            return {
                darkMode: false,
                showLike: false,
                showComment: false,
                showRequest: false,

            }
        },
        mounted() {
            let theme = localStorage.getItem("theme");
            this.darkMode = theme === "dark";
            // this.getOption();
        },
        methods: {
            getOption() {
                new BaseService("user", "/GetOptions").getList().then(response => {
                    // console.log(response.data);
                    this.showLike = response.data.showLike;
                    this.showComment = response.data.showComment;
                    this.showRequest = response.data.showRequest;

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            updateOption() {
                let q = {
                    showLike: this.showLike,
                    showComment: this.showComment,
                    showRequest: this.showRequest,
                };
                new BaseService("user", "/UpdateOptions").update(q).then(response => {
                    // console.log(response.data);
                    this.$noty.success("اطلاعات با موفقیت ویرایش شد.");
                    this.$router.push({
                        name: 'home',

                    });

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$router.push({
                        name: 'home',

                    });
                });
            },

            onThemeChange(e) {
                if (e.value) {
                    EventBus.$emit('theme', 'dark');
                    localStorage.setItem("theme", 'dark');
                } else {
                    EventBus.$emit('theme', 'light');
                    localStorage.setItem("theme", 'light');
                }
            },
            onLikeChange(e) {
                this.showLike = e.value;
            },
            onCommentChange(e) {
                this.showComment = e.value;
            },
            onRequestChange(e) {
                this.showRequest = e.value;
            },


        }
    }
</script>